import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const KEY = "shg-consent";

const apply = (value) => {
  try { localStorage.setItem(KEY, value); } catch (e) { /* storage blocked */ }
  if (window.gtag) window.gtag("consent", "update", { analytics_storage: value });
};

export const openCookieSettings = () => window.dispatchEvent(new Event("shg-cookie-settings"));

export const CookieBanner = () => {
  const [open, setOpen] = useState(false);
  useEffect(() => {
    let stored = null;
    try { stored = localStorage.getItem(KEY); } catch (e) { /* storage blocked */ }
    if (!stored) setOpen(true);
    const show = () => setOpen(true);
    window.addEventListener("shg-cookie-settings", show);
    return () => window.removeEventListener("shg-cookie-settings", show);
  }, []);
  if (!open) return null;
  const choose = (v) => { apply(v); setOpen(false); };
  return (
    <div data-testid="cookie-banner" role="dialog" aria-label="Cookie consent" className="fixed bottom-[100px] lg:bottom-0 inset-x-0 z-[60] border-t backdrop-blur-xl" style={{ background: "rgba(16,16,20,0.92)", borderColor: "var(--line-strong)" }}>
      <div className="shg-container py-3 flex items-center gap-4 justify-between">
        <p className="text-xs text-[var(--text-soft)] leading-snug">
          Optional analytics cookies help us improve the site. <Link to="/privacy" className="text-[var(--red)] whitespace-nowrap">Privacy Policy</Link>
        </p>
        <div className="flex gap-2 flex-shrink-0">
          <button data-testid="cookie-reject" onClick={() => choose("denied")} className="px-4 py-1.5 rounded-full text-xs border transition-colors hover:border-[var(--red)]" style={{ borderColor: "var(--line-strong)" }}>Reject</button>
          <button data-testid="cookie-accept" onClick={() => choose("granted")} className="px-4 py-1.5 rounded-full text-xs font-medium text-white transition-opacity hover:opacity-90" style={{ background: "var(--red)" }}>Accept</button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
